import { Grid } from '@mui/material';
import { useEffect } from 'react';

interface AnimatedRightStepProps {
  id: string;
  isVisible: boolean;
}

export const AnimatedRightStep = ({ id, isVisible, children }: React.PropsWithChildren<AnimatedRightStepProps>) => {
  useEffect(() => {
    if (!isVisible) {
      const element = document.getElementById(id);
      if (element) {
        element.classList.remove(`animate__fadeIn`);
        element.classList.add(`animate__fadeOut`);
      }
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.classList.remove(`animate__fadeOut`);
        element.classList.add(`animate__fadeIn`);
      }
    }
  }, [isVisible, id]);

  return (
    <Grid
      id={id}
      container
      direction="column"
      alignItems="center"
      wrap="nowrap"
      className={`animate__animated animate__delay-1s animate__fadeIn animate__slower`}
    >
      {children}
    </Grid>
  );
};
